<template>
  <div data-server-rendered="true" id="__nuxt" class="bannerBox">
    <!---->
    <div id="__layout">
      <div id="body">
        <div class="index_body">
          <div class="head_height">
            <div class="banner_box">
              <div class="banner page_width">
                <div class="ban_top">
                  <div class="logo"></div>
                  <div class="right flex">
                    <div class="no_login" v-if="!loginTrue" @click="loginUp()">
                      登录/注册
                    </div>
                    <!--                    <div class="no_loginLeft" @click="myInformation" v-else>-->
                    <!--                      <span>我的</span>-->
                    <!--                    </div>-->
                    <div class="no_loginRight" v-if="loginTrue">
                      <span class="logout" @click="logout" v-if="loginTrue"
                      >退出</span
                      >
                    </div>
                  </div>
                </div>
                <div class="ban_btn"></div>
              </div>
            </div>
          </div>

          <div class="bord">
            <div class="notice">
              该功能可以对行业和技术进行深度分析，自动展示知识图谱，促进企业加快研发
            </div>

            <!-- 顶部功能简介 -->
            <div class="intro-section" v-if="!showGraph">
              <div class="intro-title">行业与技术一体化洞察引擎</div>
              <div class="intro-content">
                <p>
                  通过大模型与多源数据融合，本系统可以自动识别<span class="highlight-text">上下游产业链结构</span>、
                  <span class="highlight-text">关键技术路径</span>以及<span class="highlight-text">市场竞争格局</span>，
                  帮助企业在决策前快速看清行业全貌。
                </p>
                <p>
                  您只需输入一个精准的产品词，系统即可自动生成<span class="highlight-text">行业知识图谱</span>、
                  <span class="highlight-text">技术知识图谱</span>以及<span class="highlight-text">可视化行业分析报告</span>，
                  有效支撑技术布局、项目立项、投融资评估等关键场景。
                </p>
              </div>
            </div>

            <div class="search-row"  v-if="!showGraph">
              <div class="search-item">
                <span class="search-label">产品领域：</span>
                <el-input
                    placeholder="请输入准确的产品词"
                    clearable
                    class="search-input"
                    v-model="companyName"
                />
              </div>
              <div class="search-buttons">
                <el-button
                    class="search-button"
                    type="primary"
                    @click="fetchIndustryChain()"
                >
                  立即查询
                </el-button>
                <el-button
                    v-if="textShow"
                    class="search-button reset-button"
                    type="info"
                    @click="changeStatus()"
                >
                  重新查询
                </el-button>
              </div>
            </div>

            <!-- 功能介绍卡片 -->
            <div class="features-section" v-if="!showGraph">
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="el-icon-s-data"></i>
                </div>
                <div class="feature-title">行业知识图谱</div>
                <div class="feature-desc">自动构建完整的行业产业链知识图谱，直观展示上下游关系和产业结构</div>
              </div>
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="el-icon-share"></i>
                </div>
                <div class="feature-title">技术分析</div>
                <div class="feature-desc">深度分析技术发展趋势、创新热点和专利布局，为研发决策提供依据</div>
              </div>
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="el-icon-s-marketing"></i>
                </div>
                <div class="feature-title">市场洞察</div>
                <div class="feature-desc">提供市场规模、竞争格局、投资机会等全方位市场分析报告</div>
              </div>
            </div>

            <!-- 统计信息 -->
            <div class="stats-section" v-if="!showGraph">
              <div class="stat-item">
                <div class="stat-number">{{ industryCount || '1000+' }}</div>
                <div class="stat-label">覆盖行业</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{ companyCount || '5000+' }}</div>
                <div class="stat-label">企业数据</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{ patentCount || '10000+' }}</div>
                <div class="stat-label">专利分析</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{ reportCount || '800+' }}</div>
                <div class="stat-label">分析报告</div>
              </div>
            </div>

            <!-- 使用流程引导 -->
            <div class="usage-section" v-if="!showGraph">
              <div class="usage-title">推荐使用流程</div>
              <div class="usage-steps">
                <div class="usage-step">
                  <div class="usage-step-number">1</div>
                  <div class="usage-step-text">在上方输入框中填写您关注的产品领域或细分行业名称</div>
                </div>
                <div class="usage-step">
                  <div class="usage-step-number">2</div>
                  <div class="usage-step-text">点击「立即查询」，自动生成行业知识图谱与技术知识图谱</div>
                </div>
                <div class="usage-step">
                  <div class="usage-step-number">3</div>
                  <div class="usage-step-text">下滑查看系统自动生成的可视化行业分析报告，辅助研发布局与决策</div>
                </div>
              </div>
            </div>

            <!--            <img class="img" src="/favicons.ico" alt="" v-if="showGraph"/>-->
            <div class="containerDic" v-if="showGraph">
              <span class="containerSpan">
                {{ companyName + "行业知识图谱：" }}
              </span>
            </div>
            <div class="containerHy" v-if="showGraph">
              <div id="containerHy" class="graph-container"></div>
              <div v-if="loading" class="loading">
                <div class="spinner"></div>
                <p>数据正在生成中，请耐心等待......</p>
                <p>该模型包含数据查询、复杂逻辑推导、界面图形生成，请耐心等待1-2分钟</p>
              </div>
            </div>

            <div class="containerDownDiv" v-if="showGraph">
              <span class="containerDownSpan">
                {{ companyName + "技术知识图谱：" }}
              </span>
            </div>
            <div class="containerDown" v-if="showGraph">
              <div id="containerDown" class="graph-container"></div>
              <div v-if="loadingDown" class="loading">
                <div class="spinner"></div>
                <p>数据正在生成中，请耐心等待......</p>
                <p>该模型包含数据查询、复杂逻辑推导、界面图形生成，请耐心等待1-2分钟</p>
              </div>
              <!--              <div class="textClass" v-html="textDetail"></div>-->
            </div>

            <div class="containerDownDiv" v-if="showGraph">
              <span class="containerDownSpan">
                {{ companyName + "行业分析：" }}
              </span>
            </div>
            <div class="containerDownText" v-if="showGraph">
              <AdaptiveIframe
                  :src="htmlUrl"
                  custom-class="concept-iframe"
                  :min-height="500"
                  :height-margin="0"
                  :retry-count="1"
                  :retry-interval="1000"
              />
              <!-- <div  class="textClass" v-html="textDetail"></div> -->
              <!--              <div id="containerDown" class="graph-container"></div>-->
              <div v-if="loadingDown2" class="loading">
                <div class="spinner"></div>
                <p>数据正在生成中，请耐心等待......</p>
                <p>该模型包含数据查询、复杂逻辑推导、界面图形生成，请耐心等待1-2分钟</p>
              </div>
            </div>

            <el-button
                class="queryButton"
                type="primary"
                @click="changeStatus()"
                v-if="textShow"
            >
              重新查询
            </el-button>
          </div>
        </div>

        <!---下面背景图 -->
        <div style="background: #252525">
          <img
              src="../assets/img/c02ddf2d50ba0a9c37c54f6b278d02a.png"
              alt
              class="foot_bg"
          />
          <div class="website">
            <div class="max_wid">
              <div class="max_lef">
                <!--                  <div class="labe2">版权所有：泰安市科学技术局</div>-->
                <div class="labe2">
                  通讯地址：泰安市高新区正阳门大街28号国家高创中心西塔422号
                </div>
                  <div class="classLabe2">
                    <div class="labe2Left">
                      主办单位：泰山科技大市场
                      <span class="view-count-inline">
                        <i class="el-icon-view"></i>
                        <span>{{ viewCount }} 浏览</span>
                      </span>
                    </div>
                    <div class="labe2Right">技术支持：0538-8265266</div>
                  </div>
              </div>
              <div class="max_rig">
                <!--              <div class="label">服务电话：</div>-->
                <div class="labe2">联系方式：18953878448</div>
                <div class="labe2">邮编：271000</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PersonalInformation from "./PersonalInformation .vue";
import InformationAdmin from "@/views/InformationAdmin.vue";
import PersonalFrom from "@/views/PersonalFrom.vue";
import unionFrom from "@/views/unionFrom.vue";
import HistoricalRecords from "@/views/historicalRecords.vue";
import AdaptiveIframe from "@/components/AdaptiveIframe.vue";
import {
  artificialIntelligence,
  derivativeDiagram,
  derivativeDiagramDown, visit,

} from "@/api/http";
import {changeStatus} from "@/api/login";
import {Graph, treeToGraphData} from "@antv/g6";
import {getHtml, addGraphRecord, editGraphRecord} from '@/api/concept';
import {getToken as getCookieAdminToken} from '@/utils/auth';

export default {
  components: {
    HistoricalRecords,
    PersonalFrom,
    unionFrom,
    xinxi: PersonalInformation,
    InformationAdmin,
    AdaptiveIframe,
  },
  data() {
    return {
      viewCount:0,
      htmlUrl: "",
      graphHy: null,   // 行业知识图谱实例
      graphDown: null, // 技术知识图谱实例
      loadingDown: false,
      loadingDown2: false,
      optionsIndex: null,
      options: [
        {
          value: 0,
          label: "行业知识图谱",
        },
        {
          value: 1,
          label: "技术知识图谱",
        },
      ],
      textDetail: "",
      showGraph: false,
      loading: false,
      message: " ",
      text_content: "",
      ws: null,
      sizeForm: {
        companyName: "", //公司名
        staffSize: "", //人员规模
        personnel: "", //研发人员
        mainOperatingIncome: "", //主营业收入
        investment: "", //研发投入
      },
      rawData: "", // 用于存储从API获取的完整数据
      parts: [], // 用于逐步显示的数据
      //展示数据
      textShow: false,
      //加载中
      isLoading: false,
      hisShow: true,
      loginTrue: "", //是否登录
      companyName: "",
      text: "",
      keywords: ["企业概况"],
      output: "",
      token: "",
      industryCount: 0,
      companyCount: 0,
      patentCount: 0,
      reportCount: 0,
    };
  },

  created() {
    this.getToken();
    this.login();
  },
  mounted() {
    this.initViewCount();
    this.initStats();
  },

  methods: {

    async initViewCount() {
      const pageKey = this.$route?.path || 'Industry';
      try {
        const res = await visit({ pageKey });
        const data = res && res.data !== undefined ? res.data : res;
        if (data && (data.code === 200 || data.code === 0)) {
          this.viewCount = data.data;
        } else if (typeof data === 'number') {
          this.viewCount = data;
        } else if (data && typeof data.data === 'number') {
          this.viewCount = data.data;
        }
      } catch (e) {
        console.error('浏览量上报失败', e);
      }
    },

    async initStats() {
      try {
        // 这里可以从API获取统计数据，暂时使用默认值
        this.industryCount = '1200+';
        this.companyCount = '8000+';
        this.patentCount = '15000+';
        this.reportCount = '1200+';
      } catch (e) {
        console.error('统计数据获取失败', e);
      }
    },

    getTextDetail(item) {
      const query =
          "请为" + item + "生成HTML行业分析报告，要求包含以下内容：\n" +
          "\n" +
          "产业集群分布\n" +
          "列出全国主要产业聚集区（文字+中国地图热力图）\n" +
          "示例数据标注：广东占比XX%，江苏XX%\n" +
          "龙头企业分析\n" +
          "列举5家知名企业（名称+市占率/核心技术）\n" +
          "用柱状图对比企业营收规模\n" +
          "高校研究动态\n" +
          "列出3所重点研究院校及研究方向\n" +
          "用标签云展示高频研究关键词\n" +
          "设计要求：\n" +
          "如果没有数据支撑可以不需要生成图" +
          "宽度1200px居中，主题色#2A5CAA" +
          "图表高度≤300px，优先SVG" +
          "仅使用原生SVG/Canvas/D3.js（基础版）绘制图表（禁止使用ECharts/Chart.js等第三方库）" +
          "关键数据加粗变色" +
          "交付完整HTML文件（无外部链接/时间戳）"
      // "我是做" +
      // item +
      // "行业的老板，请根据我的行业分别解析以下问题: 1.该行业在在全国在哪地方有产业集群 2.在全国有哪些著名企业 3.该行业或者产品那个大学在研究," +
      //   "按照以上内容生成结果，有数据部分适当写柱状图或折线图等简单图表，图表高度、宽度要适应网页大小，高度不超过500px, 不要有外部链接的图片，宽度1200居中 ，没数据的就不用图表，适当用主题色突出标题和重点部分，交付：提供完整HTML文件,不需要注释,不要出现生成报告时间,不要出现按钮;";
      console.log("item", item, query);
      getHtml({concat: query.replaceAll("%", ""),stream:"false"}).then(res => {
        if (res.code === 200) {
          this.htmlUrl = res.data;
          this.loadingDown2 = false;
        } else {
          this.$message({
            message: "请求失败",
            type: "error",
          });
        }
      })
    },

    changeStatus() {
      // 销毁行业知识图谱
      if (this.graphHy) {
        this.graphHy.destroy();
        this.graphHy = null;
      }
      // 销毁技术知识图谱
      if (this.graphDown) {
        this.graphDown.destroy();
        this.graphDown = null;
      }
      // 重置加载状态
      this.loading = false;
      this.loadingDown = false;
      this.loadingDown2 = false;
      // 清空行业分析报告地址
      this.htmlUrl = "";
      // 清空搜索框
      this.companyName = "";
      // 隐藏图谱区域
      this.textShow = false;
      this.showGraph = false;
    },

    initGraph(data) {
      // 如果图表已存在，先销毁
      if (this.graphHy) {
        this.graphHy.destroy();
        this.graphHy = null;
      }

      // 如果没有数据，不初始化图表内容
      if (!data) return;

      // 判断节点属于上游/中游/下游：兼容 "upstream" / "upstream-1" / "up" / "up1" 等写法
      const stageOf = (id = "") => {
        const s = String(id).toLowerCase();
        if (s.includes("up") || s.includes("上游")) return "up";
        if (s.includes("mid") || s.includes("中游")) return "mid";
        if (s.includes("down") || s.includes("下游")) return "down";
        return "";
      };

      this.graphHy = new Graph({
        container: "containerHy",
        autoFit: "view",
        padding: 100,
        data: treeToGraphData(data),
        node: {
          style: {
            size: (d) => {
              if (d.id === "root") return 100;
              if (d.depth === 1) return 60;
              return 20;
            },
            labelText: (d) => d.id === "root" ? "" : d.label,
            labelBackground: false,
            labelFontSize: (d) => {
              if (d.id === "root") return 24;
              if (d.depth === 1) return 15;
              return 16;
            },
            labelFill: "#000",
            labelPlacement: (d) => {
              if (d.id === "root" || d.depth === 1) return "center";
              const s = stageOf(d.id);
              if (s === "up") return "left";
              if (s === "down") return "right";
              return "top";
            },
            labelMaxWidth: 200,
            labelOffset: (d) => {
              if (d.id === "root" || d.depth === 1) return [0, 0];
              const s = stageOf(d.id);
              if (s === "up") return [-60, 0];
              if (s === "down") return [60, 0];
              return [0, -40];
            },
            fill: (d) => {
              if (d.id === "root") return "#8000ff";
              const s = stageOf(d.id);
              if (d.depth === 1) {
                return s === "up" ? "#4169e1" : s === "mid" ? "#00cca1" : "#cc33cc";
              }
              return s === "up" ? "#6495ed" : s === "mid" ? "#40e0d0" : "#da70d6";
            },
            stroke: "#fff",
            lineWidth: 2,
            // 添加自定义位置计算
            position: (d) => {
              if (d.depth === 1) {
                const radius = 150; // 上中下游节点到中心的距离
                const s = stageOf(d.id);
                let angle;
                if (s === "up") angle = -Math.PI / 2; // 上游在上方
                else if (s === "mid") angle = 0; // 中游在右方
                else angle = Math.PI / 2; // 下游在下方

                return {
                  x: Math.cos(angle) * radius,
                  y: Math.sin(angle) * radius,
                };
              }
              return undefined; // 其他节点使用默认布局
            },
          },
        },
        edge: {
          type: "cubic-radial",
          style: {
            lineWidth: 2,
            stroke: "#91d5ff",
            opacity: 0.6,
          },
        },
        layout: {
          type: "dendrogram",
          radial: true,
          preLayout: false,
          unitRadius: 600, // 增大半径
          preventOverlap: true,
          nodeSpacing: 200, // 增加节点间距
        },
        behaviors: [
          "drag-canvas",
          // 'zoom-canvas',
          "drag-element",
          {
            key: "hover-activate",
            type: "hover-activate",
            degree: 5,
            direction: "in",
            inactiveState: "inactive",
          },
        ],
        transforms: [],
        animation: false,
      });

      this.graphHy.render();
      this.loading = false;
    },

    async fetchIndustryChain() {
      // 与 @/utils/request 拦截器一致：Cookie Admin-Token 或 localStorage token
      const token = getCookieAdminToken() || localStorage.getItem("token");
      if (token == null || token === "") {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      } else {
        this.loading = true;
        this.loadingDown = true;
        this.loadingDown2 = true;
        this.showGraph = true;
        this.textShow = true;

        const userId = localStorage.getItem("userId");

        addGraphRecord({
          productDomain: this.companyName,
          userId: userId
        }).then((addResponse) => {
          console.log("新增图谱记录成功", addResponse);
          // RuoYi 常见格式：id 在顶层；兼容 data.id（与 ZhiqiTong.vue 一致）
          const recordId = addResponse && (addResponse.data?.id || addResponse.id);
          console.log("获取到的recordId:", recordId);

          try {
            this.getTextDetail(this.companyName);
            this.$nextTick(() => {
              derivativeDiagram(this.companyName).then((response) => {
                console.log("derivativeDiagram 响应:", response);
                if (response.code && response.code !== 200) {
                  this.$message.error("获取行业图谱失败: " + (response.msg || response.data || '未知错误'));
                  return;
                }
                this.initGraph(response.data);
              }).catch((err) => {
                console.error("derivativeDiagram 请求失败:", err);
                this.$message.error("获取行业图谱请求失败");
              });

              derivativeDiagramDown(this.companyName).then((response) => {
                console.log("derivativeDiagramDown 响应:", response);
                if (response.code && response.code !== 200) {
                  this.$message.error("获取技术图谱失败: " + (response.msg || response.data || '未知错误'));
                  return;
                }
                setTimeout(function () {
                  this.initGraphDown(response.data);
                }.bind(this), 200);

                if (recordId) {
                  editGraphRecord({
                    id: recordId,
                    responseTime: new Date().getTime()
                  }).then((editResponse) => {
                    console.log("更新图谱记录响应:", editResponse);
                  }).catch((editError) => {
                    console.error("更新图谱记录失败", editError);
                  });
                }
              }).catch((err) => {
                console.error("derivativeDiagramDown 请求失败:", err);
                this.$message.error("获取技术图谱请求失败");
              });
            });
          } catch (error) {
            console.error("处理数据出错", error);
          }
        }).catch((addError) => {
          console.error("新增图谱记录失败", addError);
          try {
            this.getTextDetail(this.companyName);
            this.$nextTick(() => {
              derivativeDiagram(this.companyName).then((response) => {
                console.log("derivativeDiagram 响应:", response);
                if (response.code && response.code !== 200) {
                  this.$message.error("获取行业图谱失败: " + (response.msg || response.data || '未知错误'));
                  return;
                }
                this.initGraph(response.data);
              }).catch((err) => {
                console.error("derivativeDiagram 请求失败:", err);
                this.$message.error("获取行业图谱请求失败");
              });

              derivativeDiagramDown(this.companyName).then((response) => {
                console.log("derivativeDiagramDown 响应:", response);
                if (response.code && response.code !== 200) {
                  this.$message.error("获取技术图谱失败: " + (response.msg || response.data || '未知错误'));
                  return;
                }
                setTimeout(function () {
                  this.initGraphDown(response.data);
                }.bind(this), 200);
              }).catch((err) => {
                console.error("derivativeDiagramDown 请求失败:", err);
                this.$message.error("获取技术图谱请求失败");
              });
            });
          } catch (error) {
            console.error("处理数据出错", error);
          }
        });
      }
    },

    // 为将来可能接收props更改添加watch
    // watch: {
    //   industryName(newVal) {
    //     if (newVal) {
    //       this.industry = newVal;
    //       this.fetchIndustryChain();
    //     }
    //   }
    // }


    initGraphDown(data) {
      // 如果图表已存在，先销毁
      if (this.graphDown) {
        this.graphDown.destroy();
        this.graphDown = null;
      }

      // 如果没有数据，不初始化图表内容
      if (!data) {
        console.warn("initGraphDown: 数据为空");
        return;
      }

      // 调试：检查数据结构
      console.log("initGraphDown 原始数据:", data);
      console.log("数据类型:", typeof data);

      // 如果数据是字符串，尝试解析
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log("解析后的数据:", data);
        } catch (e) {
          console.error("数据解析失败:", e);
          return;
        }
      }

      // 检查数据是否为有效的树形结构
      if (typeof data !== 'object' || Array.isArray(data)) {
        console.warn("数据格式不正确，需要是对象或树形结构");
        return;
      }

      // 判断节点属于上游/中游/下游：兼容 "upstream" / "upstream-1" / "up" / "up1" 等写法
      const stageOf = (id = "") => {
        const s = String(id).toLowerCase();
        if (s.includes("up") || s.includes("上游")) return "up";
        if (s.includes("mid") || s.includes("中游")) return "mid";
        if (s.includes("down") || s.includes("下游")) return "down";
        return "";
      };

      this.graphDown = new Graph({
        container: "containerDown",
        autoFit: "view",
        padding: 100,
        data: treeToGraphData(data),
        node: {
          style: {
            size: (d) => {
              if (d.id === "root") return 100;
              if (d.depth === 1) return 60;
              return 20;
            },
            labelText: (d) => d.id === "root" ? "" : d.label,
            labelBackground: false,
            labelFontSize: (d) => {
              if (d.id === "root") return 24;
              if (d.depth === 1) return 15;
              return 16;
            },
            labelFill: "#000",
            labelPlacement: (d) => {
              if (d.id === "root" || d.depth === 1) return "center";
              const s = stageOf(d.id);
              if (s === "up") return "left";
              if (s === "down") return "right";
              return "top";
            },
            labelMaxWidth: 200,
            labelOffset: (d) => {
              if (d.id === "root" || d.depth === 1) return [0, 0];
              const s = stageOf(d.id);
              if (s === "up") return [-60, 0];
              if (s === "down") return [60, 0];
              return [0, -40];
            },

            fill: (d) => {
              if (d.id === "root") return "#8000ff";
              const s = stageOf(d.id);
              if (d.depth === 1) {
                return s === "up" ? "#4169e1" : s === "mid" ? "#00cca1" : "#cc33cc";
              }
              return s === "up" ? "#6495ed" : s === "mid" ? "#40e0d0" : "#da70d6";
            },

            stroke: "#fff",
            lineWidth: 2,
            // 添加自定义位置计算
            position: (d) => {
              if (d.depth === 1) {
                const radius = 150; // 上中下游节点到中心的距离
                const s = stageOf(d.id);
                let angle;
                if (s === "up") angle = -Math.PI / 2; // 上游在上方
                else if (s === "mid") angle = 0; // 中游在右方
                else angle = Math.PI / 2; // 下游在下方

                return {
                  x: Math.cos(angle) * radius,
                  y: Math.sin(angle) * radius,
                };
              }
              return undefined; // 其他节点使用默认布局
            },
          },
        },
        edge: {
          type: "cubic-radial",
          style: {
            lineWidth: 2,
            stroke: "#91d5ff",
            opacity: 0.6,
          },
        },

        layout: {
          type: "dendrogram",
          radial: true,
          preLayout: false,
          unitRadius: 600, // 增大半径
          preventOverlap: true,
          nodeSpacing: 200, // 增加节点间距
        },

        behaviors: [
          "drag-canvas",
          // 'zoom-canvas',
          "drag-element",
          {
            key: "hover-activate",
            type: "hover-activate",
            degree: 5,
            direction: "in",
            inactiveState: "inactive",
          },
        ],

        transforms: [],
        animation: false,
      });
      this.graphDown.render();
      this.loadingDown = false;
    },

    //登录接口
    login() {
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      }
    },

    hisShowChange() {
      this.hisShow = false;
    },
    //跳转登录
    loginUp() {
      this.$router.push({path: "/login", query: {type: "5"}});
    },

    logout() {
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = true;
      this.$router.push({path: "/login", query: {type: "5"}});
      // var item = sessionStorage.getItem("token");
    },
    getToken() {
      if (localStorage.getItem("token")) {
        this.loginTrue = true;
        this.showPage = true;
      } else {
        this.loginTrue = false;
        // this.$router.push('/login')
      }
    },
  },
};
</script>

<style scoped lang="scss">
.classLabe2 {
  display: flex;

  .labe2Right {
    margin-left: 273px;
  }
}

.img {
  width: 20%;
  display: flex;
  margin: 10px 0px 10px 0;
}

.containerDownSpan {
  display: flex;
  font-size: 20px;
}

.containerSpan {
  display: flex;
  font-size: 20px;
}

::v-deep .el-input--suffix .el-input__inner {
  padding-right: 30px;
}

.containerHy {
  width: 100%;
  height: 80vh;
  background: #ffffff;
  position: relative;
}

.graph-container {
  width: 100%;
  height: 100%;
}

.containerDown {
  width: 100%;
  height: 80vh;
  background: #ffffff;
  position: relative;
}

.containerDownText {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  position: relative;
}

.graph-container {
  width: 100%;
  height: 100%;
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #0077ff;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #0077ff;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}



::v-deep .el-form-item__label {
  font-size: 20px;
}

::v-deep .el-input__inner {
  font-size: 20px;
}

::v-deep .bold-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px !important;
}

//加载中
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 遮罩层在最上面 */
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #0077ff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

/* 加载动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载文本样式 */
.loading-text {
  color: #ffffff;
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}

//数据处理样式
.content {
  white-space: pre-line; /* 保留换行符 */
  text-align: left;
  font-size: 20px;
}

::v-deep .refreshPageClass {
  font-size: 20px;
  margin-top: 30px;
  border-radius: 10px;
  width: 200px;
  height: 40px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.queryButton {
  width: 200px;
  font-size: 20px;
  margin-top: 80px;
  //margin-left: 200px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 60px;
  font-size: 20px;
}

.selectedForm {
  width: 200px;
}

.formSelectDiv {
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.label {
  margin-right: 10px; /* 控制文本和选择框之间的间距 */
}

.selectClass {
  padding: 5px;
  border: 1px solid #ccc;
  width: 500px;
  font-size: 20px;
}

.bord {
  margin: 90px auto 120px;
  padding: 20px;
  max-width: 1200px;
  min-height: 300px;
  height: auto;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 18px;
  line-height: 1.8;
}

.search-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 40px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.search-item {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 15px;
}

.search-label {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  white-space: nowrap;
  min-width: 90px;
}

.search-input {
  flex: 1;
  max-width: 500px;

  ::v-deep .el-input__inner {
    height: 46px;
    border-radius: 8px;
    border: 2px solid #e1e8ed;
    font-size: 18px;
    transition: all 0.3s ease;

    &:focus {
      border-color: #0077ff;
      box-shadow: 0 0 0 3px rgba(0, 119, 255, 0.1);
    }
  }
}

.search-buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.search-button {
  height: 46px;
  padding: 0 32px;
  background: linear-gradient(135deg, #0077ff 0%, #0056cc 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 119, 255, 0.3);
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 119, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
}

.intro-section {
  margin-bottom: 50px;
  padding: 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  color: white;
  text-align: center;
}

.intro-title {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.intro-content {
  max-width: 800px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.8;

  p {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.features-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 50px;
}

.feature-card {
  background: white;
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #0077ff 0%, #0056cc 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 32px;
  box-shadow: 0 8px 20px rgba(0, 119, 255, 0.3);
}

.feature-title {
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
}

.feature-desc {
  font-size: 17px;
  color: #666;
  line-height: 1.6;
}

.stats-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  padding: 40px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border-radius: 16px;
  text-align: center;
}

.stat-item {
  color: white;
}

.stat-number {
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.stat-label {
  font-size: 18px;
  font-weight: 500;
  opacity: 0.9;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 16px 24px;
  border-radius: 8px;
  margin-bottom: 30px;
  font-size: 18px;
  color: #0066cc;
  font-weight: 500;
  text-align: center;
}

.highlight-text {
  font-weight: 700;
  color: #ffd666;
}

.usage-section {
  margin-top: 40px;
  padding: 30px 30px 10px;
  background: #f8f9fa;
  border-radius: 16px;
  border: 1px dashed #d9dfe7;
}

.usage-title {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 24px;
  text-align: left;
}

.usage-steps {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.usage-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.usage-step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #0077ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(0, 119, 255, 0.25);
}

.usage-step-text {
  font-size: 18px;
  color: #444;
  line-height: 1.8;
}

.reset-button {
  height: 50px;
  padding: 0 40px;
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
    background: linear-gradient(135deg, #5a6268 0%, #343a40 100%);
  }

  &:active {
    transform: translateY(0);
  }
}

::v-deep .subClass {
  color: #fff !important;
  background-color: #0077ff !important;
}

.closeClass {
  color: #fff;
  background-color: #ff4d4f;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
  //text-decoration: underline;
}

.bannerBox {
  width: 100%;
}

.layout {
  width: 100%;
}

::v-deep .layout {
  display: flex;
}

.banner_box {
  height: 500px;
}

.banner_box .ban_top .right .no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.banner_box .ban_top .left img {
  width: 176px;
}

.img {
  max-width: 100%;
  border: none;
}

.banner_box .ban_top .left .div2 {
  position: relative;
  margin: 0 40px 0 80px;
  padding: 12px 20px;
  border-radius: 23px;
}

.banner_box {
  background-image: url("~@/assets/img/knowledgeGraph.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 24px 0 190px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-around;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.banner_box .ban_text {
  margin: 100px 0 43px;
  font-weight: 600;
  font-size: 54px;
  color: #fff;
  line-height: 71px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  flex: none;
}

.banner_box .btn1,
.banner_box .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.ban_btn {
  margin-top: 410px;
}

.banner_box .ban_btn .btn1 {
  border-radius: 30px;
  border: 2px solid #fff;
  color: #fff;
}

.banner_box .ban_btn .btn2 {
  border-radius: 30px;
  background: #fff;
  color: #333;
}

.banner_box .ban_btn .btn1,
.banner_box .ban_btn .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.banner_box .ban_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box .step,
.step_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box {
  background: #f7f7f7;
  padding: 90px 0 100px;
}

.step_box .step .step_top {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
}

.step_box .step .step_lab {
  margin-top: 26px;
  font-weight: 400;
  font-size: 20px;
  color: #606266;
  line-height: 27px;
}

.step_box .step .step_itm {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.page_width {
  width: 1200px;
  margin-top: 100px;
}

.step_box .step {
  flex-direction: column;
}

.step_box .step .step_itm .itm_box .num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #2238c2;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 2px solid #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 27px;
  width: 15%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 40px;
  width: 10%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit span {
  color: #2238c2;
}

.reason_box .reason .cont .cont_itm {
  margin-left: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 385px;
  height: 286px;
  padding: 62px 53px 0;
  box-sizing: border-box;
  background: #f5fbfc;
  border-radius: 12px;
  font-size: 16px;
}

.cont_itmDun {
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exchange_box .exchange .ex_left .tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  margin-bottom: 50px;
}

.exchange_box .exchange .ex_left .tit span {
  color: #2238c2;
}

.exchange_box .exchange .ex_left {
  width: 75%;
}

.exchange_box .exchange .ex_left .itm img {
  width: 24px;
  height: 24px;
  margin-right: 14px;
  font-size: 16px;
}

img {
  max-width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange .ex_left .itm {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  font-size: 16px;
}

.exchange_box {
  padding: 84px 0 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/img/lineImg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

img {
  width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.website {
  padding: 30px 0;
  background: #252525;
  justify-content: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
  color: #a8a8a8;
  background: #252525;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
  line-height: 1.6;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.logo {
  cursor: pointer;
  background-image: url("~@/assets/img/logn.png");
  background-size: 450px 70px;
  width: 450px;
  height: 70px;
  margin-bottom: 25px;
  position: relative;
}

.view-count-inline {
  display: inline-flex;
  align-items: center;
  margin-left: 16px;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(168, 168, 168, 0.6);
  font-size: 12px;
  color: #d0d0d0;

  span {
    line-height: 1;
  }

  i {
    margin-right: 4px;
    font-size: 14px;
  }
}

.problem_box {
  width: 100%;
  background: #fff;
  padding: 90px 0 131px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.problem_box_inline {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 131px;
}

.problem_box_inline .pro_tit span {
  color: #009eb8;
}

.problem_box_inline .pro_tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
  text-align: center;
  margin-bottom: 80px;
}

.problem_box_inline .pro_lab {
  font-weight: 700;
  margin-bottom: 13px;
  font-size: 20px;
  color: #333;
}

.problem_box_inline .pro_cont {
  font-weight: 400;
  font-size: 16px;
  color: #666;
  line-height: 28px;
}

.mb40 {
  margin-bottom: 40px;
}

.form-container {
  max-width: 1200px;
  margin: 90px auto 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.steps {
  display: flex;
  justify-content: space-between;

  position: relative;
  padding: 0 40px;
  margin-top: 30px;
  margin-bottom: 60px;
}

.step {
  display: flex;
  align-items: center;
  z-index: 1;
}

.step-number {
  width: 24px;
  height: 24px;
  background: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 14px;
}

.step-text {
  font-size: 20px;
}

.step::after {
  content: "";
  display: inline-block;
  width: 127px;
  height: 1px;
  z-index: 0;
  margin-left: 6px;
}

.steps .step:last-child:after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  background: #e8e8e8;
  z-index: 0;
  margin-left: 0;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 20px;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 20px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 60px;
}

.file-upload {
  border: 1px dashed #d9d9d9;
  padding: 20px;
  text-align: center;
  background: #fafafa;
  border-radius: 4px;
}

.upload-button {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.file-info {
  font-size: 20px;
  color: #666;
  margin-top: 12px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-top: 8px;
}

.form-containerquery {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-bottom: 20px;
}

.certificate-type {
  border: 1px solid #e8e8e8;
  padding: 15px;
  margin-bottom: 20px;
}

.certificate-warning {
  color: #ff4d4f;
  font-size: 12px;
  margin-bottom: 10px;
}

.certificate-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.certificate-option {
  border: 1px solid #e8e8e8;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.certificate-option:hover {
  border-color: #40a9ff;
}

.certificate-option.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

.certificate-option img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.rights-section {
  margin-bottom: 20px;
}

.rights-grid {
  width: 90%;
  margin: 0 auto;

  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.right-option {
  width: 25%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

.agreement {
  display: flex;
  align-items: center;

  margin-bottom: 20px;
  justify-content: center;

  input {
    width: 16px;
    height: 16px;
  }
}

.agreement a {
  color: #1890ff;
  text-decoration: none;
}

.submit-buttonLeft {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 25%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-buttonRight {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 10%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-button {
}

.submit-button:hover {
  background: #40a9ff;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 60px;
}

.cha_xun {
  padding: 3.5rem 18.33rem 10.42rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tips {
    font-size: 1.33rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #232323;
    line-height: 2.25rem;
  }
}

.cha_xun .tips {
  margin-top: 2.08rem;
  padding: 0.92rem 1.92rem 3.25rem;
  background: rgba(39, 130, 255, 0.1);
  border: 1px solid #2782ff;
  border-radius: 0.25rem;
  display: flex;
  align-items: baseline;
}

.cha_xun .tips div[data-v-71571416] {
  font-size: 1.33rem;
  font-weight: 400;
  color: #232323;
  line-height: 2.25rem;
  font-size: 20px;
}

.cha_xun .input_box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cha_xun .file_hash[data-v-71571416],
.cha_xun .unified_numbering[data-v-71571416] {
  display: flex;
  align-items: center;
  margin-top: 4.25rem;
}

.cha_xun .file_hash .el-input[data-v-71571416] .el-input__inner,
.cha_xun .unified_numbering .el-input[data-v-71571416] .el-input__inner {
  border-radius: 0.25rem;
  font-size: 1.4rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.cha_xun .query[data-v-71571416] {
  cursor: pointer;
  margin-top: 5.67rem;
  padding: 1.17rem 10rem;
  display: inline-block;
  background: #2782ff;
  box-shadow: 0 0.3rem 3rem 0 rgba(29, 62, 187, 0.2);
  border-radius: 0.25rem;
  font-size: 1.67rem;
  font-weight: 700;
  color: #fff;
  line-height: 2rem;
}

.me {
  max-width: 1200px;
  height: auto;
  margin: 90px auto 90px;
  padding: 20px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .labe2 {
  font-size: 16px;
}

.no_loginLeft {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.no_loginRight {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
  margin-left: 10px;
}

.el-dropdownClass {
  width: 50%;
}

.dataclass {
  font-size: 20px;
}

.submitClass {
  display: flex;
}

.el-textarea .el-input__count {
  margin-bottom: 10px !important;
}

.right-optionValue {
  width: 30%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}

.textClass {
  white-space: pre-line; /* 保留换行符 */
  text-align: left;
  font-size: 20px;
}
</style>
